import { createContext, useContext } from "react";
import { Entity } from "@common/types/entity";

interface AccountsConnectionContextValue {
    showAccountTypeWarning: boolean;
    defaultEntity?: Entity;
}

export const AccountsConnectionContext =
    createContext<AccountsConnectionContextValue>({
        showAccountTypeWarning: false,
        defaultEntity: undefined,
    });

export function useAccountsConnectionContext() {
    const ctx = useContext(AccountsConnectionContext);

    if (!ctx) {
        throw new Error("Show only be used inside AccountsConnectionProvider ");
    }

    return ctx;
}
